import Slider from "react-slick";
import {
  NextArrow,
  PrevArrow,
} from "../../components/SlickButtons/SlickButtons";
import { Link } from "react-router-dom";
import "./TopSales.css";
import { useGetTopSales } from "../../hooks/useGetTopSales";
import CardSkeleton from "../../components/Skeleton/CardSkeleton";
import useDevice from "../../hooks/useDevice";

function TopSales() {
  const { isMobile, isTablet } = useDevice();

  const { data: topSales, isLoading } = useGetTopSales();

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: isMobile ? 2 : isTablet ? 4 : 8,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <section className="TopSales">
      <div className="section-title">
        <h3>Top Sales</h3>
      </div>

      <Slider {...settings}>
        {isLoading
          ? Array.from({ length: 8 }).map((_, index) => (
              <CardSkeleton
                key={index}
                width={"95%"}
                height={isTablet ? "312px" : "230px"}
              />
            ))
          : topSales?.map((product) => {
              return (
                <Link
                  to={`product/${product.slug.toLowerCase()}`}
                  className={`product ${product.slug}`}
                  key={product.slug}
                >
                  <img src={product.images[0].src} alt={product.name} />
                  <p className="product-card-name">{product.name}</p>
                </Link>
              );
            })}
      </Slider>
    </section>
  );
}

export default TopSales;
